import { render } from "./DashboardRecentActivity.vue?vue&type=template&id=d43e8384"
import script from "./DashboardRecentActivity.vue?vue&type=script&lang=js"
export * from "./DashboardRecentActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__